import React, { useState } from 'react';
import '../WidgetEditTypes/TopWidgetEdit.css';
import ColorPickerSection from './ColorPickerSection';

function ColorSettingsSection({ colors, colorConfig, editData, handleInputChange }) {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };
    
    return (
        <div>
            {/* Color Settings Header mit Toggle */}
            <div 
                className="elegant-input-container clickable-toggle"
                onClick={!isExpanded ? toggleExpanded : undefined}
            >
                <div className="elegant-input-header">
                    <div className="elegant-label-row">
                        <label className="elegant-input-label">Color Settings</label>
                        <button 
                            type="button"
                            className={`elegant-dots-toggle ${isExpanded ? 'expanded' : ''}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleExpanded();
                            }}
                            title="Color Settings"
                        >
                            <span className="dot"></span>
                            <span className="dot"></span>
                            <span className="dot"></span>
                        </button>
                    </div>
                    {isExpanded && (
                        <div className="elegant-input-controls expanded">
                            <ColorPickerSection 
                                colors={colors}
                                colorConfig={colorConfig}
                                editData={editData}
                                handleInputChange={handleInputChange}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ColorSettingsSection;
